<template>
  <el-table
    class="my-table-hok_v1"
    size="mini"
    :data="tableData"
    :header-cell-style="{
      background: 'rgb(35, 36, 72)',
      color: 'rgb(188, 189, 212)',
      'font-size': '14px',
      'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
      'font-weight': 'normal',
    }"
    :span-method="cellMerge"
  >
    <!-- 机型 -->
    <el-table-column prop="model" label="机型" width="100"></el-table-column>

    <!-- 画质 -->
    <el-table-column prop="quality" label="画质" width="80"></el-table-column>

    <!-- 动作 -->
    <el-table-column
      v-if="showActionColumn"
      prop="action"
      label="动作"
      width="80"
    >
      <template #default="scope">
        <span style="color: rgb(51, 157, 255)">
          {{ scope.row.action }}
        </span>
      </template>
    </el-table-column>

    <!-- 日期 -->
    <el-table-column :label="dateColumnLabel" width="140">
      <template #default="scope">
        <span
          :style="
            'margin-left:' + (scope.row?.data.level == 0 ? '0px' : '10px')
          "
        >
          {{ scope.row.data?.date
          }}<i
            style="cursor: pointer"
            v-if="scope.row?.data?.level == 0 && scope.row.show"
            @click="expandCheck(scope.row)"
            :class="scope.row.check ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ></i>
        </span>
        <span
          @click="expandCheckAdd(scope.row)"
          style="color: #70c1f1; cursor: pointer"
          v-if="scope.row.many"
          >(查看更多)</span
        >
      </template>
    </el-table-column>

    <!-- 分支 -->
    <el-table-column prop="branch" label="分支" width="90"></el-table-column>

    <!-- SVN -->
    <el-table-column prop="svn" label="SVN" width="80"></el-table-column>

    <!-- 结论 -->
    <el-table-column label="结论" width="70">
      <template #default="{ row }">
        <span :style="{ color: getResultColor(row) }">{{ row.result }}</span>
      </template>
    </el-table-column>

    <!-- 指标列（标准/数值） -->
    <el-table-column
      v-for="metric in metricColumns"
      :key="metric.label"
      :label="metric.label"
    >
      <el-table-column label="标准" width="60">
        <template #default="{ row }">
          <span style="color: rgb(51, 157, 255)">{{
            row?.standard?.[metric.key] || "/"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数值" width="60">
        <template #default="{ row }">
          <span :style="`color: ${getValueColor(row, metric.key)}`">{{
            row?.[metric.key] ?? "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <!-- PerfDog -->
    <el-table-column label="PerfDog" width="80">
      <template #default="{ row }">
        <a
          v-if="row.perfdogUrl && row.perfdogUrl !== '--'"
          target="_blank"
          style="
            cursor: pointer;
            color: rgb(24, 144, 255);
            text-decoration: none;
          "
          :href="row.perfdogUrl"
          >{{ row.perfdogText || "对比链接" }}</a
        >
        <span v-else>--</span>
      </template>
    </el-table-column>

    <!-- SVN链接 -->
    <el-table-column label="SVN链接" width="90">
      <template #default="{ row }">
        <a
          v-if="row.svnUrl && row.svnUrl !== '--'"
          target="_blank"
          style="
            cursor: pointer;
            color: rgb(24, 144, 255);
            text-decoration: none;
          "
          :href="row.svnUrl"
          >SVN链接</a
        >
        <span v-else>--</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  name: "PosterTable",
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
    skinId: {
      type: [String, Number],
      default: "",
    },
    // 海报主数据请求地址
    posterUrl: {
      type: String,
      default: "/report/poster_data_v2/",
    },
    // 「查看更多」分页数据请求地址
    posterMoreUrl: {
      type: String,
      default: "/report/poster_data_more_v1/",
    },
    // 业务类型（透传到请求参数）
    type: {
      type: [String, Number],
      default: "",
    },
    showActionColumn: {
      type: Boolean,
      default: false,
    },
    dateColumnLabel: {
      type: String,
      default: "版本日期",
    },
    metricColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tableData: [],
      posterRes: {}, // 原始数据，按机型存储
    };
  },

  watch: {
    skinId() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      if (!this.skinId) return;
      try {
        this.tableData = [];
        const { data } = await axios(this.posterUrl, {
          params: {
            project: this.project,
            skin_id: this.skinId,
          },
        });
        this.posterRes = {};

        for (const model in data) {
          let entries = data[model];

          if (!Array.isArray(entries)) {
            entries = [];
            for (const action in data[model]) {
              let show = data[model][action].length > 1 ? true : false;

              data[model][action].forEach((v) => {
                entries.push({ ...v, action, show });
              });
            }
          }
          this.posterRes[model] = entries;
          entries.forEach((v) => {
            if (v.level == 0) {
              this.tableData.push(
                this.buildRow(model, v.action ?? "", v, v.show),
              );
            }
          });
        }
        this.recomputeMany();
      } catch (e) {
        console.error("poster_data_v2 请求失败", e);
        ElMessage.error("海报数据获取失败");
      }
    },

    buildRow(model, action, v, show) {
      return {
        ...v,
        model,
        action: action || v.action || "",
        quality: v.quality || "",
        data: { date: v.date, level: v.level },
        show: !!show,
        check: true,
        many: false,
        branch: v.custom_version || "--",
        perfdogUrl: v.link || "",
        perfdogText: v.link ? "查看" : "",
        svnUrl: v["svn链接"] || "",
      };
    },

    // 合并单元格（按机型）
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0) return;

      const model = row.model;
      const rows = this.tableData;
      let startIdx = -1;
      let count = 0;

      for (let i = 0; i < rows.length; i++) {
        if (rows[i].model === model) {
          if (startIdx === -1) startIdx = i;
          count++;
        }
      }

      if (rowIndex === startIdx && count > 1) {
        return { rowspan: count, colspan: 1 };
      } else if (count > 1) {
        return { rowspan: 0, colspan: 0 };
      }
    },

    // 展开/收起同一日期下的子版本（level 0 / level 1）
    expandCheck(data) {
      data.check = !data.check;
      const model = data.model;
      const action = data.action;
      if (!data.check) {
        const addData = this.posterRes[model].filter(
          (v) => v.level != 0 && (action ? v.action == action : true),
        );
        const list = addData.map((v) =>
          this.buildRow(model, v.action ?? "", v, false),
        );
        const index = this.tableData.findIndex(
          (r) =>
            r.model == model &&
            r.action == action &&
            r.data.date == data.data.date,
        );
        if (index !== -1) {
          this.tableData.splice(index + 1, 0, ...list);
        }
      } else {
        this.tableData = this.tableData.filter(
          (r) =>
            !(
              r.model === model &&
              r.data.level === 1 &&
              (action ? r.action == action : true)
            ),
        );
      }
      this.recomputeMany();
    },

    // 日期列「查看更多」——调用 posterMoreUrl
    async expandCheckAdd(data) {
      const model = data.model;
      const action = data.action;
      const page = this.tableData.filter(
        (r) => r.model == model && r.action == action,
      ).length;
      try {
        const { data: moreData } = await axios(this.posterMoreUrl, {
          params: {
            project: this.project,
            skin_id: this.skinId,
            device_name: model,
            action,
            page,
          },
        });

        if (moreData && moreData.length > 0) {
          const list = [];
          moreData.forEach((v) => {
            const item = { ...v, action: v.action ?? action ?? "" };
            this.posterRes[model].push(item);
            list.push(this.buildRow(model, item.action, item, false));
          });
          this.insertAfterLastOccurrenceAdd(model, list);
          this.recomputeMany();
        } else {
          ElMessage.error("暂无更多数据");
        }
      } catch (e) {
        console.error("poster_data_more_v1 请求失败", e);
        ElMessage.error("查看更多数据获取失败");
      }
    },

    insertAfterLastOccurrenceAdd(model, newDevice) {
      let lastIndex = -1;
      this.tableData.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });
      if (lastIndex !== -1) {
        this.tableData.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        this.tableData.push(...newDevice);
      }
    },

    // 重新计算每个机型分组的最后一行，标记「查看更多」
    recomputeMany() {
      const occurrenceCount = {};
      const lastOccurrence = {};
      this.tableData.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;

        if (!occurrenceCount[key]) occurrenceCount[key] = 0;
        occurrenceCount[key]++;
        lastOccurrence[key] = index;
      });
      this.tableData.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      });
    },

    getResultColor(row) {
      const result = row.result;
      if (result == "达标") {
        return "rgb(121, 217, 127)";
      } else if (result == "不达标") {
        return "rgb(255, 76, 55)";
      }
    },

    getValueColor(row, item) {
      const color = row?.color?.[item];

      if (color == "green") {
        return "rgb(121, 217, 127);";
      } else if (color == "red") {
        return "rgb(255, 76, 55);";
      } else {
        return "";
      }
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.el-table {
  --el-bg-color: transparent;
}

.el-table :deep(th),
.el-table :deep(tr),
.el-table :deep(td),
.el-table :deep(tr:hover),
.el-table :deep(tr:hover td) {
  color: #fff;
  background-color: rgb(34, 37, 41);
  border-bottom: 1px solid #606469;
}

.el-table :deep(tr:hover td) {
  color: #4ed8da;
}

.my-table-hok_v1 :deep(.el-table__row .cell) {
  background: rgb(35, 36, 72);
  color: rgb(188, 189, 212);
  font-size: 14px;
  font-family: "Microsoft YaHei", "Microsoft YaHei-Regular";
}

.el-table :deep(.el-table__body-wrapper) {
  background-color: rgb(34, 37, 41);
}
</style>
